<template>
  <div id="mfooter">
    <!-- 底部 -->
    <footer class="mfooter">
      <div class="box1">
        <p class="pti1">SUBMIT DEMAND</p>
        <div class="allbox-hd mbflex mforms">
          <input type="text" class="dw1 ipu1" v-model="uname" placeholder="您的昵称" />
          <input type="text" class="dw1 ipu1" v-model="utel" maxlength="11" placeholder="您的联系方式" />
          <button type="button" class="dw1 mbtn1 trans5" @click="getQuote(uname,utel)"><label
              class="sp1">提交专属需求</label></button>
        </div>
      </div>
      <div class="box2">
        <div class="allbox-hd mbflex mdbox">
          <div class="dlogo">
            <img :src="webList.wx_qrcode" class="img1">
            <router-link to="/"><img :src="pubImg + 'logo.png'" class="img2"></router-link>
          </div>
          <div class="dlink" v-for="(item,index) in navlink" :key="index">
            <router-link class="ar1 pt1 trans3" :to="item.plink">{{item.ptitle}}</router-link>
            <router-link class="ar1 pt2 trans3" v-for="(citem,cidx) in item.children" :key="cidx" :to="citem.link">
              {{citem.title}}
            </router-link>
          </div>
          <div class="pbox">
            <p class="p1">联系我们：</p>
            <p class="p2">{{webList.hotline}}</p>
            <p class="p3">{{webList.company_address}}</p>
          </div>
        </div>
      </div>
      <div class="mbflex box3">
        <a target="_blank" href="https://beian.miit.gov.cn/" class="mbflex">
          <img :src="pubImg + 'beian.png'">
          <label class="sp2">渝ICP备17007227号-2</label>
          <!-- <label class="sp2">{{webList.beian}}</label> -->
        </a>
      </div>
    </footer>
    <!-- 底部 -->
  </div>
</template>

<script>
  import Qs from 'qs'

  export default {
    name: 'mheader',
    data() {
      return {
        pubImg: localStorage.getItem("pubImg"), //图片路径
        pubPostUrl: localStorage.getItem("pubPostUrl"), //接口前缀
        uname: '',
        utel: '',
        navlink: [{
            ptitle: '关于我们',
            plink: '/about',
            children: [{
              title: '公司简介',
              link: '/about',
            }, {
              title: '经典项目',
              link: '/case',
            }, {
              title: '专属工程',
              link: '/project',
            }, {
              title: '新闻资讯',
              link: '/news',
            }]
          }, {
            ptitle: '售后服务',
            plink: '/',
            children: [{
              title: '报修通道',
              link: '/',
            }, {
              title: '售后服务',
              link: '/',
            }, {
              title: '投诉建议',
              link: '/',
            }]
          },
          {
            ptitle: '快速通道',
            plink: '/',
            children: [{
              title: '网站导航',
              link: '/',
            }, {
              title: '友情链接',
              link: '/',
            }, {
              title: '加入我们',
              link: '/contact',
            }]
          }
        ], //底部链接
        webList: "", //网站配置
      }
    },
    props: {
      pagename:String, //页面名称
    },
    mounted() {
      let that = this;
      that.getWebList();
    },

    methods: {
      //网站配置
      getWebList() {
        let that = this;
        that.axios({
          method: 'get',
          url: that.pubPostUrl + 'get_website_conf',
          data: "",
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res) => {
          // console.log(res);
          let mres = res.data.data;
          that.webList = mres;
          localStorage.setItem('webAddr',mres.company_address);
          localStorage.setItem('whotline',mres.hotline);
        }).catch((err) => {
          // console.log(err);
        });
      },

      //获取报价(姓名，电话)
      getQuote(uname, utel) {
        let that = this;
        that.mpublic.isRequired(uname).then(() => {
          that.mpublic.isTel(utel).then(() => {
            that.axios({
              method: 'post',
              url: that.pubPostUrl + "set_form_data",
              data: {
                name: uname, //姓名
                tel: utel, //电话
                email: "", //邮箱
                remark: "", //留言
                page: 'pc-' + that.pagename,
              },
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              transformRequest: [function(data) {
                let ret = '';
                ret = Qs.stringify(data);
                return ret;
              }],
            }).then((res) => {
              // console.log(res);
              let code = res.data.code;
              if (code == 1) {
                that.$message.success(res.data.msg);
              } else {
                that.$message.error(res.data.msg);
              }
            }).catch((err) => {
              // console.log(err);
            });
          }, err => {
            that.$message.warning("请填写正确的手机号");
            that.utel = '';
          })
        }, err => {
          that.$message.warning("请填写您的称呼");
        })
      },

    }
  }
</script>


<style>
  /* 底部 */
  .mfooter {
    background: #1B1D1F;
  }

  .mfooter .box1 {
    background: #32373B;
    padding-bottom: 3.7rem;
  }

  .mfooter .box1 .pti1 {
    font-size: 1.6rem;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    padding: 3rem;
  }

  .mfooter .box1 .mforms {
    justify-content: center;
  }

  .mfooter .box1 .mforms .dw1 {
    flex: 0 1 24%;
    height: 3.4rem;
    line-height: 3.4rem;
    margin: 0 .6rem;
  }

  .mfooter .box1 .ipu1 {
    padding: 0 1rem;
    color: #FFFFFF;
    background: #495156;
  }

  .mfooter .box1 .mbtn1 {
    text-align: center;
    color: #FFFFFF;
    background: #6C193C;
    font-size: 1.3rem;
  }

  .mfooter .box1 .mbtn1 .sp1 {
    background: url(../../static/img/dic_01.png) no-repeat left center;
    background-size: 17px auto;
    -webkit-background-size: 17px auto;
    padding-left: 26px;
  }

  .mfooter .box1 .mbtn1:hover {
    background: #1B1D1F;
  }

  .mfooter .box2 {
    padding: 4.3rem 0;
    border-bottom: 1px solid #393E42;
  }

  .mfooter .box2 .mdbox {
    align-items: stretch;
    color: rgba(255, 255, 255, .6);
    font-size: .8rem;
  }

  .mfooter .box2 .dlogo {
    text-align: center;
  }

  .mfooter .box2 .img1 {
    width: 7rem;
    height: 7rem;
    display: block;
    margin: 0 auto;
  }

  .mfooter .box2 .img2 {
    width: 13rem;
    margin-top: 1rem;
  }

  .mfooter .box2 .dlink {
    overflow: hidden;
    text-align: center;
  }

  .mfooter .box2 .dlink .ar1 {
    color: rgba(255, 255, 255, .6);
    cursor: pointer;
    display: block;
    line-height: 2rem;
    font-size: .8rem;
  }

  .mfooter .box2 .dlink .pt1 {
    font-size: 1.14rem;
    margin-bottom: 1.2rem;
  }

  .mfooter .box2 .dlink .ar1:hover {
    color: #c6437a;
  }

  .mfooter .box2 .pbox {
    max-width: 30%;
    overflow: hidden;
  }

  .mfooter .box2 .pbox .p1 {
    font-size: 1.14rem;
    margin-bottom: 1.2rem;
  }

  .mfooter .box2 .pbox .p2 {
    font-size: 1.5rem;
    color: #FFFFFF;
    margin: 1.2rem auto;
  }

  .mfooter .box2 .pbox .p3 {
    background: url(../../static/img/dic_02.png) no-repeat left 2px;
    background-size: 10px auto;
    -webkit-background-size: 10px auto;
    padding-left: 18px;
  }

  .mfooter .box3 {
    padding: 2rem;
    font-size: .8rem;
    justify-content: center;
    color: rgba(255, 255, 255, .6);
    text-align: center;
  }

  .mfooter .box3 .sp1 {
    margin-right: 14px;
  }

  .mfooter .box3 .sp2 {
    color: rgba(255, 255, 255, .6);
    margin-left: 6px;
  }

  /* 底部 */
</style>



// WEBPACK FOOTER //
// src/components/mfooter.vue